import { render, staticRenderFns } from "./auxiliary.vue?vue&type=template&id=63cbf8d8&scoped=true"
import script from "./auxiliary.vue?vue&type=script&lang=js"
export * from "./auxiliary.vue?vue&type=script&lang=js"
import style0 from "./auxiliary.vue?vue&type=style&index=0&id=63cbf8d8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cbf8d8",
  null
  
)

export default component.exports